module.exports = __webpack_public_path__ + "img/icon22.5fb089a0.png";